module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.04787f81.woff2";